export type TablePlayer = {
  id: number;
  name: string;
  gameId: number | null;
  hasCharacter: boolean;
};

export type TablePending = {
  gameId: number;
  gameName: string;
  requestId: number;
  playerId: number;
  playerName: string;
};

const PLAYERS_KEY = 'tablePlayers';
const PENDING_KEY = 'tablePending';

function readList<T>(key: string): T[] {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function notify() {
  window.dispatchEvent(new Event('table-players'));
}

export function readTablePlayers(): TablePlayer[] {
  return readList<TablePlayer>(PLAYERS_KEY);
}

export function writeTablePlayers(players: TablePlayer[]) {
  localStorage.setItem(PLAYERS_KEY, JSON.stringify(players));
  notify();
}

export function rememberTablePlayer(player: TablePlayer) {
  const players = readTablePlayers().filter((entry) => entry.id !== player.id);
  players.push(player);
  writeTablePlayers(players);
  return players;
}

export function updateTablePlayer(id: number, patch: Partial<TablePlayer>) {
  const players = readTablePlayers().map((entry) => (entry.id === id ? { ...entry, ...patch } : entry));
  writeTablePlayers(players);
  return players;
}

export function readTablePending(): TablePending[] {
  return readList<TablePending>(PENDING_KEY);
}

export function writeTablePending(pending: TablePending[]) {
  if (pending.length === 0) localStorage.removeItem(PENDING_KEY);
  else localStorage.setItem(PENDING_KEY, JSON.stringify(pending));
  notify();
}

export function clearTableSession() {
  localStorage.removeItem(PLAYERS_KEY);
  localStorage.removeItem(PENDING_KEY);
  notify();
}
